export enum PasswordFormKeys {
    Password = 'login-password',
}

export const REQUEST_PASSWORD_TIMER_KEY = 'request-password-timer';
